import Vue from 'vue'
import VueRouter from 'vue-router'
// https://github.com/declandewet/vue-meta
import VueMeta from 'vue-meta'
// Adds a loading bar at the top during page loads.
import NProgress from 'nprogress/nprogress'
import store from '@state/store'
import routes from './routes'
import userHasPermissions from '@utils/userPermissions'

Vue.use(VueRouter)
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'metaInfo',
})

const router = new VueRouter({
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach((routeTo, routeFrom, next) => {
  const authRequired = routeTo.matched.some(route => route.meta.authRequired)
  if (!authRequired) return next()

  const permittedRoles = routeTo.meta.permission
  if (!store.getters['auth/loggedIn']) {
    redirectToLogin()
  } else {
    if (!store.getters['data/dictionariesIsLoaded']) {
      NProgress.start()
      store.dispatch('data/getAllDictionaries')
      store.dispatch('globalSettings/load')
    }
    if (permittedRoles) checkRoles(permittedRoles)
    else return next()
  }

  function checkRoles(permittedRoles) {
    if (store.state.auth.isLoaded) {
      if (userHasPermissions(store.state.auth.userRole, permittedRoles))
        return next()
      else redirectToAccessDenied()
    } else {
      store.watch(
        state => state.auth.isLoaded,
        isLoaded => {
          if (isLoaded) {
            if (userHasPermissions(store.state.auth.userRole, permittedRoles))
              next()
            else redirectToAccessDenied()
          } else {
            next({ name: 'home' })
          }
        }
      )
    }
  }

  function redirectToLogin() {
    next({ name: 'login' })
  }

  function redirectToAccessDenied() {
    next({ name: '403' })
  }
})

router.beforeResolve((routeTo, routeFrom, next) => {
  // If this isn't an initial page load...
  if (routeFrom.name) {
    // Start the route progress bar.
    NProgress.start()
  }
  next()
})

router.afterEach((routeTo, routeFrom) => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})

export default router
